// extracted by mini-css-extract-plugin
module.exports = {"header":"hu","headerBg":"hv"};